<div class="d-flex flex-column alig-items-center">
  <div class="login-form mx-auto">
    <ng-container [ngSwitch]="type">
      <div *ngSwitchCase="I2faType.SMS">
        <app-confirm-2fa-sms
          [token]="token"
          [blockButtons]="true"
          (onSubmit)="handleSubmit()"
          (onCancel)="handleCancel()"
          (onTokenChange)="handleTokenChange($event)"
        ></app-confirm-2fa-sms>
      </div>
    </ng-container>
  </div>
</div>
